// extracted by mini-css-extract-plugin
export default {"mainHeader":"InStoreClinic_mainHeader__LwtuO"};